import Label from '../Label'
import Row from '../IndentedRow'
import Dropdown from './Dropdown'

const FromRow = ({ className, mailbox, mailboxes, onMailboxClick }) => {
  return (
    <Row className={className} flex="1 0 100%">
      <Label>From:</Label>
      <Dropdown
        mailbox={mailbox}
        mailboxes={mailboxes}
        onClick={onMailboxClick}
        ml={1}
      />
    </Row>
  )
}

export default FromRow
